import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

let last = { path: "", at: 0 };

export function Tracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (last.path === pathname && Date.now() - last.at < 2000) return;
    last = { path: pathname, at: Date.now() };
    api.post("/track", { path: pathname }).catch(() => {});
  }, [pathname]);
  return null;
}
